import React from "react";
import PropTypes from 'prop-types';
import useOnScrollThreshold from "../hooks/useOnScrollThreshold.mjs";
import {NeuroMessage} from "@ignitesales/neuro-application";
import SummaryActionButtons from "./ContactShareButtons";

const SocialActionHeader = ({ elementId, threshold }) => {
    const componentClass = 'socialActionHeader';
    const isVisible = useOnScrollThreshold(threshold, elementId);
    return (isVisible && <div className={componentClass}>
        <NeuroMessage id="socialActionHeader.title" tagName="h1" shouldHideIfNotFound={true} />
        <SummaryActionButtons />
    </div>);
};

SocialActionHeader.propTypes = {
    elementId: PropTypes.string,
    threshold: PropTypes.number
};

SocialActionHeader.defaultProps = {
    elementId: 'root',
    threshold: 500
};

export default SocialActionHeader;
